import { useTranslation } from 'react-i18next';
import { GridControlled } from '@customer/components/tables/grid/GridControlled';
import useInvestigations from './useInvestigations';
import { InvestigationBasicModel } from '@customer/store/apis/investigationsApi';
import Page from '@customer/templates/page/Page';
import PageHeader from '@customer/components/layout/page-header/PageHeader';
import CardTable from '@customer/components/tables/card-table/CardTable';
import { ConnectivitySnackbar } from '@dmc/ui';
import { QueryTag } from '@customer/store/api';
import { TagDescription } from '@reduxjs/toolkit/query';
import { FilterGroup } from '@customer/filters/types';
import { ProtectedElement } from '@customer/components/state-management/protected-element/ProtectedElement';
import { Permission } from '@customer/permissions';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { ModelName } from '@customer/store/types';

const modelName = ModelName.Investigation;
const tableSliceKey = 'Investigations';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Investigation, id: 'LIST' },
];

export function Investigations() {
  const { t } = useTranslation();

  const {
    columnDefs,
    investigations,
    error,
    countAll,
    countFilter,
    hasData,
    noDataDescription,
    onRowClick,
    onCreate,
  } = useInvestigations();

  return (
    <>
      <Page
        fullWidth
        header={
          <PageHeader
            title={t('Collection.Title', { modelName })}
            sliceKey={tableSliceKey}
            tagsToClearOnRefresh={tagsToClearOnRefresh}
            filterProps={{
              filterGroup: FilterGroup.Investigations,
              countAll,
              countFilter,
              transKey: 'Collection.Filtered',
              filteredTransKey: 'Collection.FilteredShowing',
              modelName,
            }}
            actions={
              <ProtectedElement permission={Permission.InvestigationsAll}>
                <VdsButton variant="primary" onClick={onCreate}>
                  {t('Create')}
                  <VdsIcon slot="icon-left" svgIcon="add" />
                </VdsButton>
              </ProtectedElement>
            }
          />
        }
      >
        <CardTable hasData={hasData} noDataDescription={noDataDescription}>
          <GridControlled<InvestigationBasicModel>
            sliceKey={tableSliceKey}
            rowData={investigations}
            columnDefs={columnDefs}
            onRowClick={onRowClick}
          />
        </CardTable>
      </Page>
      <ConnectivitySnackbar
        error={error}
        message={t('Collection.FetchError', { modelName })}
        title={t('Error')}
      />
    </>
  );
}

export default Investigations;
